import { makeStyles } from "@material-ui/core";

export const exportButtonStyle = makeStyles((theme) => ({
    actionButton: {
        marginRight: '16px'
    }
}));